import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const SuccessModal = ({ isOpen = false, title = 'Success', message = '', onClose = () => {} }) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} size="sm">
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody>{message}</ModalBody>
      <ModalFooter>
        <Button color="success" onClick={onClose}>OK</Button>
      </ModalFooter>
    </Modal>
  );
};

export default SuccessModal;


